//Request
export const BEGIN_REQUEST = 'DM.BEGIN_REQUEST';
export const END_REQUEST = 'DM.END_REQUEST';

//Panel
export const ADD_PANEL = 'DM.ADD_PANEL';
export const DELETE_PANEL = 'DM.DELETE_PANEL';
export const LOAD_CONTEXT = 'DM.LOAD_CONTEXT';
export const LOAD_CONTEXT_TRANSACTION = 'DM.LOAD_CONTEXT_TRANSACTION';
export const UPDATE_PANEL = 'DM.UPDATE_PANEL';
export const UPDATE_RECENT_FILES = 'DM.UPDATE_RECENT_FILES';
export const UPDATE_FAVORITES = 'DM.UPDATE_FAVORITES';
export const UPDATE_LOADING_STATUS = 'DM.UPDATE_LOADING_STATUS';
export const ADD_ITEM_TO_FAVORITES = 'DM.ADD_ITEM_TO_FAVORITES';
export const REMOVE_ITEM_FROM_FAVORITES = 'DM.REMOVE_ITEM_FROM_FAVORITES';
export const REMOVE_ITEM_FROM_FAVORITES_ACTION = 'DM.REMOVE_ITEM_FROM_FAVORITES_ACTION';
export const REMOVE_ITEMS_FROM_FAVORITES_ACTION = 'DM.REMOVE_ITEMS_FROM_FAVORITES_ACTION';
export const ON_SIDEBAR_COLLAPSE_CHANGED = 'DM.ON_SIDEBAR_COLLAPSE_CHANGED';
export const UPDATE_VISIBLE_ACTIONS_TRANSACTION = 'DM.UPDATE_VISIBLE_ACTIONS_TRANSACTION';
export const ON_SIDEBAR_EXPANDED_KEYS_CHANGED = 'DM.ON_SIDEBAR_EXPANDED_KEYS_CHANGED';

//Scene
export const ADD_SCENE = 'DM.ADD_SCENE';
export const ADD_SCENE_TRANSACTION = 'DM.ADD_SCENE_TRANSACTION';
export const SET_SELECTED_ITEMS = 'DM.SET_SELECTED_ITEMS';
export const SET_SHOW_MODE = 'DM.SET_SHOW_MODE';
export const DELETE_SCENE = 'DM.DELETE_SCENE';
export const ADD_SCENE_HISTORY = 'DM.ADD_SCENE_HISTORY';
export const LOAD_OPTIONS_TRANSACTION = 'DM.LOAD_OPTIONS_TRANSACTION';
export const LOAD_OPTIONS = 'DM.LOAD_OPTIONS';
export const LOAD_OBJECT_IDS = 'DM.LOAD_OBJECT_IDS';
export const LOAD_SELECTED_OBJECTS = 'DM.LOAD_SELECTED_OBJECTS';
export const LOAD_SELECTED_OBJECTS_TRANSACTION = 'DM.LOAD_SELECTED_OBJECTS_TRANSACTION';
export const EXECUTE_COMMAND_TRANSACTION = 'DM.EXECUTE_COMMAND_TRANSACTION';
export const SET_SCENE_ITEMS = 'DM.SET_SCENE_ITEMS';
export const UPDATE_CONTEXT_MENU_VISIBLE_ON = 'DM.UPDATE_CONTEXT_MENU_VISIBLE_ON';
export const UPDATE_SCENE_ACTIONS = 'DM.UPDATE_SCENE_ACTIONS';
export const LOAD_CONTEXT_AND_SET_SELECTED_ITEMS = 'DM.LOAD_CONTEXT_AND_SET_SELECTED_ITEMS';
export const UPDATE_SCENE_NAME = 'DM.UPDATE_SCENE_NAME';
export const UPDATE_SCENE_PARENTS = 'DM.UPDATE_SCENE_PARENTS';
export const ADD_FILES_TO_UPLOAD = 'DM.ADD_FILES_TO_UPLOAD';
export const LOAD_MORE_ITEMS = 'DM.LOAD_MORE_ITEMS';
export const SET_LOAD_MORE_DATA = 'DM.SET_LOAD_MORE_DATA';
export const UPDATE_SCENE_PAGINATION_DATA = 'DM.UPDATE_SCENE_PAGINATION_DATA';
export const REMOVE_SCENES_ACTION = 'DM.REMOVE_SCENES_ACTION';
export const RENEW_REFRESH_KEY = 'DM.RENEW_REFRESH_KEY';
export const REFRESH_GRID = 'DM.REFRESH_GRID';
export const CREATED_THUMBNAIL = 'DM.CREATED_THUMBNAIL';
export const DM_BRANCH_CREATED = 'DM.BRANCH_CREATED';
export const DM_CONTENT_UPDATED = 'DM.CONTENT_UPDATED';
export const DM_DAV_OPERATION_FAILED = 'DM.DAV_OPERATION_FAILED';

//Data
export const LOAD_SUB_OBJECTS_TRANSACTION = 'DM.LOAD_SUB_OBJECTS_TRANSACTION';
export const LOAD_DATA_OBJECTS_TRANSACTION = 'DM.LOAD_DATA_OBJECTS_TRANSACTION';

export const ADD_DATA_OBJECT = 'DM.ADD_DATA_OBJECT';
export const EDIT_DATA_OBJECT = 'DM.EDIT_DATA_OBJECT';
export const ADD_DATA_OBJECTS = 'DM.ADD_DATA_OBJECTS';

export const ON_COMMAND_RECEIVED_TRANSACTION = 'DM.ON_COMMAND_RECEIVED_TRANSACTION';
export const ON_QUICK_ACCESS_CLICK_TRANSACTION_ACTION =
	'DM.ON_QUICK_ACCESS_CLICK_TRANSACTION_ACTION';

export const ADD_DM_OBJECT = 'DM.ADD_DM_OBJECT';
export const REMOVE_DM_OBJECT = 'DM.REMOVE_DM_OBJECT';
export const UPDATE_DM_OBJECT = 'DM.UPDATE_DM_OBJECT';

export const GET_OBJECTS_CHILDS = 'DM.GET_OBJECTS_CHILDS';

export const ON_BREADCRUMB_NAVIGATION_BTN_CLICKED = 'DM.ON_BREADCRUMB_NAVIGATION_BTN_CLICKED';
export const REMOVE_DATA_FROM_RECENT = 'DM.REMOVE_DATA_FROM_RECENT';
export const REMOVE_MULTIPLE_DATA_FROM_RECENT = 'DM.REMOVE_MULTIPLE_DATA_FROM_RECENT';

export const SET_DM_PARAMETERS_ACTION = 'DM.SET_DM_PARAMETERS_ACTION';
export const SET_RECYCLEBIN_SETTINGS_ACTION = 'DM.SET_RECYCLEBIN_SETTINGS_ACTION';
export const SET_RECYCLEBIN_SETTINGS_TRANSACTION = 'DM.SET_RECYCLEBIN_SETTINGS_TRANSACTION';

//Workflow - DMPlugin
export const OPEN_WF_PANEL = 'DM_PLUGIN.OPEN_WF_PANEL';

export const OPEN_SCAN_MODAL_TRANSACTION = 'DM.OPEN_SCAN_MODAL_TRANSACTION';
export const SET_CONTEXT_MENU_DATA_LOADING = 'DM.SET_CONTEXT_MENU_DATA_LOADING';

//Capture
export const ADD_ITEM_TO_SCANNED_DOCUMENTS = 'DM.ADD_ITEM_TO_SCANNED_DOCUMENTS';
export const DELETE_ITEM_FROM_SCANNED_DOCUMENTS = 'DM.DELETE_ITEM_FROM_SCANNED_DOCUMENTS';
export const CLEAR_SCANNED_DOCUMENTS = 'DM.CLEAR_SCANNED_DOCUMENTS';
